import React, { useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import Version from '../../version'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	useEffect(() => {
		if(client){

		}
	},[dispatch, t, client])

	return (
        <Container className='mt-5 px-5'>
            <Row>
                <Col>
                    <h1>{client?.username}, {t('admin.dashboard.welcome')}</h1>
                </Col>
            </Row>
			<Row>
				<Col xs={12} md={4} className='my-3'>
					<Link to="/admin/users" >
						<Card>
							<Card.Body className='text-center'>
								<div><i className='fas fa-users fa-3x'></i></div>
								{t('admin.dashboard.users')}
							</Card.Body>
						</Card>
					</Link>
				</Col>
				<Col xs={12} md={4} className='my-3'>
					<Link to="/admin/restaurants" >
						<Card>
							<Card.Body className='text-center'>
								<div><i className='fas fa-utensils fa-3x'></i></div>
								{t('admin.dashboard.restaurants')}
							</Card.Body>
						</Card>
					</Link>
				</Col>
				<Col xs={12} md={4} className='my-3'>
					<Link to="/admin/opinions" >
						<Card>
							<Card.Body className='text-center'>
								<div><i className='fas fa-comments fa-3x'></i></div>
								{t('admin.dashboard.opinions')}
							</Card.Body>
						</Card>
					</Link>
				</Col>
			</Row>
			<Row>
				<Col className='text-center mt-3'>
					<Version/>
				</Col>
			</Row>
        </Container>
	)
}